import store from '@/store';
import { api } from '@/utils/api';
import axios from '@axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSubCategories(ctx, queryParams) {
      console.log('=== SubCategoryStoreModule fetchSubCategorys():', { queryParams });

      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;
        console.log('=== SubCategoryStoreModule businessID', businessID);

        const params = {
          businessID,
          pageNumber: queryParams.page || 1,
          pageSize: queryParams.perPage || 10,
          searchTerm: queryParams.q || '',
        };

        console.log('=== SubCategoryStoreModule params', params);

        api
          .get(`/SubCategories/GetByPagination/${businessID}`, { params })
          .then((response) => {
            console.log('=== SubCategoryStoreModule response', response.data);

            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data);
            } else {
              reject('Error fetching Sub Categors list');
            }
          })
          .catch((error) => reject(error));
      });
    },
    fetchSubCategory(ctx, { id }) {
      return new Promise((resolve, reject) => {
        const businessID = store.state.user.businessID;

        api
          .get(`/SubCategories/LoadSelectedData/${businessID}/${id}`)
          .then((response) => {
            console.log('=== SubCategoryStoreModule response', response.data);
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data.entity);
            } else {
              reject('Error fetching Sub Category list');
            }
          })
          .catch((error) => reject(error));
      });
    },
    saveSubCategory(ctx, subCategoryData) {
      const businessID = store.state.user.businessID;
      subCategoryData.businessID = businessID;

      return new Promise((resolve, reject) => {
        api
          .post(`/SubCategories/Save/${businessID}`, { entity: subCategoryData })
          .then((response) => {
            console.log(response);
            resolve(response.data.data);
          })
          .catch((error) => reject(error));
      });
    },
    deleteSubCategory(ctx, { id }) {
      const businessID = store.state.user.businessID;
      const userID = store.state.user.userID;

      return new Promise((resolve, reject) => {
        console.log('=== SubCategoryStoreModule delete SubCategory called with id:', id);

        api
          .delete(`/SubCategories/Delete/${businessID}/${id}?userID=${userID}`)
          .then((response) => {
            console.log('=== SubCategoryStoreModule delete Sub Category response:', response);
            if ('status' in response.data && response.data.status === 'success') {
              resolve(response.data.data);
            } else {
              reject(response.data.message);
            }
          })
          .catch((error) => {
            console.error('=== SubCategoryStoreModule delete Sub Category error:', error);
            reject(error);
          });
      });
    },
  },
};
